// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkin-status {
  position: absolute;
  top: 15px;
  right: 10px;
}

.checkin-no {
  color: #FD3F3F;
  font-size: 25px;
}

.checkin-yes {
  color: #A1F593;
  font-size: 25px;
}

.checkin-true-number,
.checkin-true-text,
.checkin-false-number,
.checkin-false-text {
  margin: 0 auto;
  padding: 0;
}

.checkin-true-number,
.checkin-false-number {
  font-size: 3em;
  font-weight: 600;
}

.checkin-true-text,
.checkin-false-text {
  font-size: 1.1em;
}

.checkin-true-number {
  color: #A1F593;
}

.checkin-false-number {
  color: #FD3F3F;
}

.hifen {
  font-size: 2.5em;
  font-weight: bold;
}

.item-list {
  padding-bottom: 4px;
}
.item-list ion-avatar {
  width: 72px;
  height: 72px;
  background: var(--bg-color);
  display: flex;
}
.item-list ion-avatar .cus-picture {
  width: 32px;
  height: 32px;
  margin: auto;
  border-radius: 0;
  opacity: 0.6;
}
.item-list ion-label {
  height: 72px;
}
.item-list ion-label > h2 {
  font-family: var(--font);
  font-weight: 600;
}
.item-list ion-label > h3, .item-list ion-label p {
  font-family: var(--font);
  font-weight: 300;
}

ion-searchbar {
  --icon-color: rgba(0,0,0,0.6);
  font-family: var(--font);
  font-weight: 400;
  width: 90%;
  margin: auto;
}

.header-divider .letter {
  font-size: 18px;
  position: relative;
  color: var(--text-color-2nd-login-desktop);
  left: 5%;
  top: 10px;
}
.header-divider .bar {
  width: 90%;
  margin: auto;
  height: 1px;
  background-color: var(--text-color-2nd-login-desktop);
  position: relative;
  opacity: 0.09;
  top: 15px;
}

.btn-box {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  padding: 10px 0 15px;
  border-top: 1px solid #ECEAF3;
  background-color: #ffffff;
}

.btn-default {
  border-radius: 2px;
  width: 60%;
  min-width: 216px;
  height: 40px;
}
.btn-default span {
  text-transform: none;
  font-family: var(--font);
  font-weight: 700;
  font-size: 16px;
  margin-left: 8px;
  color: #fff;
}

.background {
  height: 100%;
}
.background .checkin-detail-content {
  padding-bottom: 74px;
  height: 100%;
}
.background .checkin-detail-content .counter-container {
  display: flex;
  width: 90%;
  height: 65px;
  margin: 0px auto 4px;
  padding-top: 11px;
}
.background .checkin-detail-content .counter-container .present h2 {
  font-family: var(--font);
  font-weight: 700;
  margin: 0;
}
.background .checkin-detail-content .counter-container .present span {
  font-family: var(--font);
  font-weight: 400;
  font-size: 14px;
  opacity: 0.6;
}
.background .checkin-detail-content .counter-container .divider {
  width: 1px;
  background: rgba(32, 17, 87, 0.09);
  height: 65%;
  margin: auto 27px;
}
.background .checkin-detail-content .counter-container .absent h2 {
  font-family: var(--font);
  font-weight: 700;
  margin: 0;
}
.background .checkin-detail-content .counter-container .absent span {
  font-family: var(--font);
  font-weight: 400;
  font-size: 14px;
  color: #9596BC;
}
.background .checkin-detail-content ion-searchbar {
  max-height: 58px;
}
.background .checkin-detail-content cdk-virtual-scroll-viewport {
  height: calc(100% - 65px - 58px);
}

@media screen and (min-width: 768px) {
  .background {
    width: 50%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/checkin-detail/checkin-detail.page.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;AACJ;;AAEA;EACI,cAAA;EACA,eAAA;AACJ;;AAEA;EACI,cAAA;EACA,eAAA;AACJ;;AAEA;;;;EAII,cAAA;EACA,UAAA;AACJ;;AAEA;;EAEI,cAAA;EACA,gBAAA;AACJ;;AAEA;;EAEI,gBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,gBAAA;EACA,iBAAA;AACJ;;AAEA;EAEI,mBAAA;AAAJ;AACI;EACI,WAAA;EACA,YAAA;EACA,2BAAA;EACA,aAAA;AACR;AAAQ;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;AAEZ;AACI;EACI,YAAA;AACR;AAAQ;EACI,wBAAA;EAA0B,gBAAA;AAGtC;AADQ;EACI,wBAAA;EAA0B,gBAAA;AAItC;;AACA;EAEI,6BAAA;EACA,wBAAA;EAA0B,gBAAA;EAC1B,UAAA;EACA,YAAA;AAEJ;;AAEI;EACI,eAAA;EACA,kBAAA;EACA,0CAAA;EACA,QAAA;EACA,SAAA;AACR;AACI;EACI,UAAA;EACA,YAAA;EACA,WAAA;EACA,qDAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;AACR;;AAGA;EACI,eAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;EACA,oBAAA;EACA,6BAAA;EACA,yBAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;AAAJ;AAEI;EACI,oBAAA;EACA,wBAAA;EAA0B,gBAAA;EAC1B,eAAA;EACA,gBAAA;EACA,WAAA;AACR;;AAGA;EACI,YAAA;AAAJ;AAEI;EACI,oBAAA;EACA,YAAA;AAAR;AAEQ;EACI,aAAA;EACA,UAAA;EACA,YAAA;EACA,oBAAA;EACA,iBAAA;AAAZ;AAEgB;EACI,wBAAA;EAA0B,gBAAA;EAC1B,SAAA;AACpB;AACgB;EACI,wBAAA;EAA0B,gBAAA;EAC1B,eAAA;EACA,YAAA;AAEpB;AACY;EACI,UAAA;EACA,kCAAA;EACA,WAAA;EACA,iBAAA;AAChB;AAEgB;EACI,wBAAA;EAA0B,gBAAA;EAC1B,SAAA;AACpB;AACgB;EACI,wBAAA;EAA0B,gBAAA;EAC1B,eAAA;EACA,cAAA;AAEpB;AAGQ;EACI,gBAAA;AADZ;AAIQ;EACI,gCAAA;AAFZ;;AAQA;EACI;IACE,UAAA;EALJ;AACF","sourcesContent":[".checkin-status {\n    position: absolute;\n    top: 15px;\n    right: 10px;\n}\n\n.checkin-no {\n    color: #FD3F3F;\n    font-size: 25px;\n}\n\n.checkin-yes {\n    color: #A1F593;\n    font-size: 25px;\n}\n\n.checkin-true-number,\n.checkin-true-text,\n.checkin-false-number,\n.checkin-false-text {\n    margin: 0 auto;\n    padding: 0;\n}\n\n.checkin-true-number,\n.checkin-false-number {\n    font-size: 3em;\n    font-weight: 600;\n}\n\n.checkin-true-text,\n.checkin-false-text {\n    font-size: 1.1em;\n}\n\n.checkin-true-number {\n    color: #A1F593;\n}\n\n.checkin-false-number {\n    color: #FD3F3F;\n}\n\n.hifen {\n    font-size: 2.5em;\n    font-weight: bold;\n}\n\n.item-list {\n    // margin: 0 26px;\n    padding-bottom: 4px;\n    ion-avatar{\n        width: 72px;\n        height: 72px;\n        background: var(--bg-color);\n        display: flex;\n        .cus-picture {\n            width: 32px;\n            height: 32px;\n            margin: auto;\n            border-radius: 0;\n            opacity: 0.6;\n        }\n    }\n    ion-label{\n        height: 72px;\n        > h2 {\n            font-family: var(--font); font-weight: 600;;\n        }\n        > h3, p{\n            font-family: var(--font); font-weight: 300;;\n        }\n    }\n}\n\nion-searchbar{\n    //--background: var(--bg-color);\n    --icon-color: rgba(0,0,0,0.6);\n    font-family: var(--font); font-weight: 400;;\n    width: 90%;\n    margin: auto;\n}\n.header-divider{\n    // margin-top: 5px;\n    .letter{\n        font-size: 18px;\n        position: relative;\n        color: var(--text-color-2nd-login-desktop);\n        left: 5%;\n        top: 10px;\n    }\n    .bar{\n        width: 90%;\n        margin: auto;\n        height: 1px;\n        background-color: var(--text-color-2nd-login-desktop);\n        position: relative;\n        opacity: 0.09;\n        top: 15px;\n    }\n}\n\n.btn-box{\n    position: fixed;\n    width: 100%;\n    bottom: 0;\n    left: 0;\n    padding: 10px 0 15px;\n    border-top: 1px solid #ECEAF3;\n    background-color: #ffffff;\n}\n\n.btn-default {\n    border-radius: 2px;\n    width: 60%;\n    min-width: 216px;\n    height: 40px;\n\n    span {\n        text-transform: none;\n        font-family: var(--font); font-weight: 700;;\n        font-size: 16px;\n        margin-left: 8px;\n        color: #fff;\n    }\n}\n\n.background {\n    height: 100%;\n\n    .checkin-detail-content {\n        padding-bottom: 74px;\n        height: 100%;\n\n        .counter-container{\n            display: flex;\n            width: 90%;\n            height: 65px;\n            margin: 0px auto 4px;\n            padding-top: 11px;\n            .present{\n                h2{\n                    font-family: var(--font); font-weight: 700;;\n                    margin: 0;\n                }\n                span{\n                    font-family: var(--font); font-weight: 400;;\n                    font-size: 14px;\n                    opacity: 0.6;\n                }\n            }\n            .divider{\n                width: 1px;\n                background: rgb(32 17 87 / 0.09);\n                height: 65%;\n                margin: auto 27px;\n            }\n            .absent{\n                h2{\n                    font-family: var(--font); font-weight: 700;;\n                    margin: 0;\n                }\n                span{\n                    font-family: var(--font); font-weight: 400;;\n                    font-size: 14px;\n                    color: #9596BC;\n                }\n            }\n        }\n\n        ion-searchbar {\n            max-height: 58px;\n        }\n\n        cdk-virtual-scroll-viewport {\n            height: calc(100% - 65px - 58px);\n            // width: 100%;\n        }\n    }\n}\n\n@media screen and (min-width: 768px) {\n    .background{\n      width: 50%;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
